export const appName = 'overview';
